import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useImperativeHandle, useMemo, useState } from 'react';
import { Box, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './WebsiteStep.module.scss';
export const GetWebsiteStepTID = (parentTestId)=>getTestIds({
        parentTestId
    });
const normalizeUrl = (raw)=>{
    const trimmed = raw.trim();
    if (!trimmed) return trimmed;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return "https://".concat(trimmed);
};
const isValidUrl = (raw)=>{
    try {
        const url = new URL(normalizeUrl(raw));
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
        return /\.[a-z]{2,}$/i.test(url.hostname);
    } catch (unused) {
        return false;
    }
};
export const WebsiteStep = (param)=>{
    let { testId, values, onChange, onContinue, onSubmittingChange, submitRef } = param;
    const testIds = useMemo(()=>GetWebsiteStepTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('vendorOnboarding.websiteStep');
    const { api } = useStoreActions();
    const [error, setError] = useState();
    const handleSubmit = useCallback(async ()=>{
        const trimmed = values.url.trim();
        if (trimmed && !isValidUrl(trimmed)) {
            setError(t.invalidUrl());
            return;
        }
        setError(undefined);
        if (!trimmed) {
            onContinue(null);
            return;
        }
        const normalized = normalizeUrl(trimmed);
        onSubmittingChange === null || onSubmittingChange === void 0 ? void 0 : onSubmittingChange(true);
        try {
            const result = await api.branding.extractFromWebsite(normalized);
            onContinue(result);
        } catch (unused) {
            onContinue(null);
        } finally{
            onSubmittingChange === null || onSubmittingChange === void 0 ? void 0 : onSubmittingChange(false);
        }
    }, [
        api,
        onContinue,
        onSubmittingChange,
        t,
        values.url
    ]);
    useImperativeHandle(submitRef, ()=>({
            submit: handleSubmit
        }), [
        handleSubmit
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        testId: testIds.WebsiteStepTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Box, {
            className: styles.input,
            children: /*#__PURE__*/ _jsx(TextField, {
                bi: {
                    name: 'vendor_onboarding_website'
                },
                value: values.url,
                onChange: (e)=>{
                    setError(undefined);
                    onChange({
                        url: e.target.value
                    });
                },
                placeholder: t.placeholder(),
                error: error != null,
                helperText: error,
                collapseHelperText: false,
                testId: testIds.WebsiteStepTestIds.UrlInput()
            })
        })
    });
};
